import { Winda } from "./Winda";

function getLocalStorage() {
  if (!Winda.isPresent) {
    return null;
  }

  try {
    return window.localStorage;
  } catch (error) {
    console.warn("localStorage is not available", error);
    return null;
  }
}

export const localStorage = getLocalStorage();
